
import { Component, Prop, Vue } from 'vue-property-decorator'
import MediaItem from '@/types/mediaItem'
import MediaFilelist from '@/components/media/Filelist.vue'

@Component({
  components: { MediaFilelist }
})
export default class Filelist extends Vue {
  @Prop({ default: () => [] }) media!: MediaItem[]
  @Prop({ default: false }) canDelete!: boolean
}
